import { Component } from '@angular/core';

@Component({
  selector: 'app-silent-renew',
  standalone: true,
  imports: [],
  templateUrl: './silent-renew.component.html',
  styleUrl: './silent-renew.component.css'
})
export class SilentRenewComponent {

}
